module.exports = __webpack_public_path__ + "static/media/Menu_Hamburger@3x.89e9066b.png";